// console.log("Device -->",navigator.userAgent)
// console.log("----> halo.js <---")
var body = document.querySelector("body"),
    doc = document,
    html = document.querySelector("html"),
    win = window,
    wrapperOverlaySlt = '.wrapper-overlay',
    iconNav,
    dropdownCart,
    miniProductList;

var wishListsArr = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
var wishListsProductsIdArr = localStorage.getItem('wishlistProductsId') ? JSON.parse(localStorage.getItem('wishlistProductsId')) : [];

localStorage.setItem('items', JSON.stringify(wishListsArr));
localStorage.setItem('wishlistProductsId', JSON.stringify(wishListsProductsIdArr));

if (wishListsArr.length) {
  wishListsArr = JSON.parse(localStorage.getItem('items'));
};



var ella = {
  init:function(){
    
    ella.wishlist();
    ella.quickView();
    if(body.classList.contains('template-product') ) {
      ella.initStickyAddToCart();
    }

  },
  wishlist: function(){
    ella.initWishListIcons();
    ella.doAddOrRemoveWishlish();
    ella.doAddFullWishlish();

    if(body.classList.contains('page-wish-list') && document.querySelectorAll('.wishlist-page').length > 0) {
      ella.initWishLists();
      ella.addAllItemsInCart();
    };
  },
  translateBlock: function (blockSelector) {
    if (window.multi_lang && translator.isLang2()) {
      translator.doTranslate(blockSelector);
    }
  },
  initWishListPagging: function() {
    var data = JSON.parse(localStorage.getItem('items'));

    var wlpaggingContainer = document.getElementById('wishlist-paginate');
    var paggingTpl = '<li class="text disabled prev"><a href="#" title="'+window.inventory_text.previous+'"><i class="fa fa-angle-left" aria-hidden="true"></i><span>'+window.inventory_text.previous+'</span></a></li>';
    var wishListCotainer = document.querySelector('[data-wishlist-container]');

    
    wlpaggingContainer.children.remove;

    var totalPages = Math.ceil(data.length / 50);

    if (totalPages <= 1) {
//       wishListCotainer.children.style.display = "block";
      return;
    }

    for (var i = 0; i < totalPages; i++) {
      var pageNum = i + 1;
      if (i === 0) paggingTpl += '<li class="active"><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
      else paggingTpl += '<li><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
        }

    paggingTpl += '<li class="text next"><a href="#" title="'+window.inventory_text.next+'"><span>'+window.inventory_text.next+'</span><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>';

    wlpaggingContainer.append(paggingTpl);

    wishListCotainer.children().each(function(idx, elm) {
      if (idx >= 0 && idx < 50) {
        $(elm).show();
      }
      else {
        $(elm).hide();
      }
    });

    wlpaggingContainer.off('click.wl-pagging').on('click.wl-pagging', 'li a', function(e) {
      e.preventDefault();

      var isPrev = $(this).parent().hasClass('prev');
      var isNext = $(this).parent().hasClass('next');
      var pageNumber = $(this).data('page');

      if (isPrev) {
        var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
        pageNumber = curPage - 1;
      }

      if (isNext) {
        var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
        pageNumber = curPage + 1;
      }

      wishListCotainer.children().each(function(idx, elm) {
        if (idx >= (pageNumber - 1) * 50 && idx < pageNumber * 50) {
          $(elm).show();
        }
        else {
          $(elm).hide();
        }
      });

      if (pageNumber === 1) {
        wlpaggingContainer.find('.prev').addClass('disabled');
        wlpaggingContainer.find('.next').removeClass('disabled');
      }
      else if (pageNumber === totalPages) {
        wlpaggingContainer.find('.next').addClass('disabled');
        wlpaggingContainer.find('.prev').removeClass('disabled');
      }
      else {
        wlpaggingContainer.find('.prev').removeClass('disabled');
        wlpaggingContainer.find('.next').removeClass('disabled');
      }

      $(this).parent().siblings('.active').removeClass('active');
      wlpaggingContainer.find('[data-page="' + pageNumber + '"]').parent().addClass('active');

    });
  },
  
  initWishLists: function() {
    if (typeof(Storage) !== 'undefined') {
      var data = JSON.parse(localStorage.getItem('items'));
      console.log(data)

      if (data.length <= 0) {
        return;
      }

      data.forEach(function(item) {
        ella.createWishListTplItem(item);
      });
      
      ella.initWishListPagging();

    } else {
      alert('Sorry! No web storage support..');
    }
  },
  
  createWishListTplItem: function(ProductHandle) {
//     console.log(ProductHandle)
    var wishListCotainer = document.querySelector('[data-wishlist-container]');

    fetch('/products/'+ProductHandle+'.js')
    .then(response => response.json())
    .then(data => {
      var product = data;
      
      
      var productHTML = '',
          price_min = Shopify.formatMoney(product.price_min, window.money_format);

      productHTML += '<div class="grid-item" data-wishlist-added="wishlist-'+product.id+'">';
      productHTML += '<div class="inner product-item" data-product-id="product-'+product.handle+'">';
      productHTML += '<div class="column col-img"><div class="product-image">';
      productHTML +='<a href="'+product.url+'" class="product-grid-image" data-collections-related="/collections/all?view=related">';
      productHTML += '<img src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">';
      productHTML += '</a></div></div>';
      productHTML += '<div class="column col-prod">';
      productHTML += '<a class="product-title" href="'+product.url+'" title="'+product.title+'">'+product.title+'</a>';
      productHTML += '<div class="product-vendor">';
      productHTML += '<a href="/collections/vendors?q='+product.vendor+'" title="'+product.vendor+'">'+product.vendor+'</a></div></div>';
      productHTML += '<div class="column col-price text-center"><div class="price-box">'+ price_min +'</div></div>';
      productHTML += '<div class="column col-options text-center">';
      productHTML += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + product.id +'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';

      if (product.available) {
        if (product.variants.length == 1) {
          productHTML += '<button data-btn-addToCart  class="btn add-to-cart-btn add-to-cart" data-product-id="'+ product.id +'" data-quantity="1" data-variant-id="'+product.variants[0].id+'" data-form-id="#wishlist-product-form-' + product.id +'" type="button">'+window.inventory_text.add_to_cart+'</button><input type="hidden" name="id" value="'+ product.variants[0].id +'" />';
        }
        if (product.variants.length > 1){
          productHTML += '<a class="btn add-to-cart-btn" title="'+product.title+'" href="'+product.url +'">'+window.inventory_text.select_options+'</a>';
        }
      } else {
        productHTML += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">'+window.inventory_text.unavailable+'</button>';
      }

      productHTML += '</form></div>';
      productHTML += '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="'+ product.handle +'" data-icon-wishlist data-id="'+ product.id +'"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg><span class="hidden wishlist-text text-hover">'+window.inventory_text.add_wishlist+'</span></a></div>';
      productHTML += '</div></div>';

      wishListCotainer.innerHTML += productHTML;
      var regex = /(<([^>]+)>)/ig;
      var href = document.querySelector('.wrapper-wishlist a.share').getAttribute("href");
      href += encodeURIComponent( product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
      document.querySelector('.wrapper-wishlist a.share').setAttribute("href", href );
      
      setTimeout(function(){
        console.log(window.enable_popup,document.querySelector(`[data-product-id="${product.id}"]`));
        if (product.available && product.variants.length == 1 ){
          document.querySelector(`[data-product-id="${product.id}"]`).addEventListener('click', event => add(event,"","",window.enable_popup));
        }
        ella.doAddOrRemoveWishlish();
      },1000)
    });
  },
  
  setAddedForWishlistIcon: function(ProductHandle) {
//     console.log("ProductHandle :: ",ProductHandle)
    var wishlistElm = document.querySelector('[data-product-handle="'+ ProductHandle +'"]'),
        idxArr = wishListsArr.indexOf(ProductHandle);
    
    if(wishlistElm != null){
      if(idxArr >= 0) {
        wishlistElm.classList.add('whislist-added');
        wishlistElm.getElementsByClassName('wishlist-text').innerText = window.inventory_text.remove_wishlist;

        ella.doAddFullWishlish();
      }
      else {
        wishlistElm.classList.remove('whislist-added');
        wishlistElm.getElementsByClassName('wishlist-text').innerText = window.inventory_text.add_wishlist;

        ella.doRemoveFullWishlish();
      };
    }

    if(wishListsArr.length == 0){
      ella.doRemoveFullWishlish();
    }
  },
  
  doAddFullWishlish: function(){
    var wishListFullElm = document.querySelector('.header__icons').getElementsByClassName('header__icon--wishlist'),
        wishListFullElm = wishListFullElm[0];

    if(!wishListFullElm.classList.contains('wishlist-full') && wishListsArr.length >= 1) {
      wishListFullElm.classList.add('wishlist-full');
    }
  },
  
  doRemoveFullWishlish: function(){
    var wishListFullElm = document.querySelector('.header__icons').getElementsByClassName('header__icon--wishlist'),
        wishListFullElm = wishListFullElm[0];

    if(wishListFullElm.classList.contains('wishlist-full') && wishListsArr.length == 0){
      wishListFullElm.classList.remove('wishlist-full');
    }
  },

  doAddOrRemoveWishlish: function(documentWrapper = "") {
    
    var d = document;
    if(documentWrapper != ""){
      d = documentWrapper;
    }
    
    
    var iconWishListsSlt = d.querySelectorAll("[data-icon-wishlist]");
//     console.log("doAddOrRemoveWishlish",iconWishListsSlt)
    
    iconWishListsSlt.forEach(function(ele){
      if(ele.classList.contains("listeneradded")){
        return;
      }
      ele.classList.add("listeneradded");
      ele.addEventListener("click",function(e){
        e.preventDefault();
        var self = this,
            productId = self.dataset.id,
            ProductHandle = self.dataset.productHandle,
            productVariantId = self.dataset.variantid,
            idInxArr = wishListsProductsIdArr.indexOf(productVariantId),
            idxArr = wishListsArr.indexOf(ProductHandle);
        
        if(!self.classList.contains('whislist-added')) {
          self.classList.add('whislist-added');
          self.getElementsByClassName("wishlist-text")[0].innerText = window.inventory_text.remove_wishlist;

          if(document.querySelectorAll('[data-wishlist-container]').length) {
            ella.createWishListTplItem(ProductHandle);
          };

          wishListsArr.push(ProductHandle);
          wishListsProductsIdArr.push(productVariantId);
          localStorage.setItem('items', JSON.stringify(wishListsArr));
          localStorage.setItem('wishlistProductsId', JSON.stringify(wishListsProductsIdArr));
        }else{
          self.classList.remove('whislist-added');
          self.getElementsByClassName('wishlist-text')[0].innerText = window.inventory_text.add_wishlist;

          if(document.querySelectorAll('[data-wishlist-added="wishlist-'+productId+'"]').length) {
            document.querySelector('[data-wishlist-added="wishlist-'+productId+'"]').remove();
          }

          wishListsArr.splice(idxArr, 1);
          wishListsProductsIdArr.splice(idInxArr, 1);
          localStorage.setItem('items', JSON.stringify(wishListsArr));
          localStorage.setItem('wishlistProductsId', JSON.stringify(wishListsProductsIdArr));

          if(document.querySelectorAll('[data-wishlist-container]').length) {
            ella.initWishListPagging();
          };
        }
        
        ella.setAddedForWishlistIcon(ProductHandle);
        
      });
    })
  },
  
  initWishListIcons: function() {
    var wishListItems = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];

    if (!wishListItems.length) {
      return;
    }

    for (var i = 0; i < wishListItems.length; i++) {
      var icon = document.querySelector('[data-product-handle="'+ wishListItems[i] +'"]');
      
      if(!icon){
        continue;
      }
      
      icon.classList.add('whislist-added');
      icon.getElementsByClassName('wishlist-text').innerText = window.inventory_text.remove_wishlist;
    };
  },
  
  
  addAllItemsInCart : function(){
    document.querySelector(".js-AddToCart").addEventListener("click",function(){
      var total_length = wishListsProductsIdArr.length,
          addLength = 0,
          items = [];
      wishListsProductsIdArr.forEach(function(item){
        var productData = {
          id: item,
          quantity: 1
        }
        items.push(productData);
      });
      var data = {
        'items':items
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then((res) => { return res.json() })
      .then((response) => {
        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      
    });
  },
  quickView: function(){
    this.initQuickView();
  },
  initQuickView: function(){
    
    var btnSelector = document.querySelectorAll(".quickview-button");
    
    btnSelector.forEach(function(ele){
      if(ele.classList.contains('eventAdded') == false){
        ele.classList.add('eventAdded')
        ele.addEventListener("click",function(e){
          e.preventDefault();
          ella.removeDrawerClass();
          // document.querySelector(".loading-cart-modal[loading-for-quickview]").style.display = "block";
          var id = this.dataset.id,
              productUrl = this.href;
          ella.doAjaxShowQuickView(id,productUrl);
          //         ella.closeSuccessModal();
        });
      }
    });
  },
  removeDrawerClass: function() {
    document.body.classList.remove("cart-drawer-open");
  },
  doAjaxShowQuickView:function(id,productUrl){
    var $this = ella;
    fetch(productUrl).then(function (response) {
      // The API call was successful!
      return response.text();
    }).then(function (html) {
      // This is the HTML from our response as a text string
      var parser = new DOMParser();
      var doc = parser.parseFromString(html,'text/html');
      doc.querySelector('[product--main-image]').setAttribute('product--main-image-flickity','');
      if(doc.querySelector('[product--thumbnail-image]')){
        doc.querySelector('[product--thumbnail-image]').setAttribute('product--thumbnail-image-flickity','');
      }
      var productHTml = `<div class="main-product-sec spaced-section">${doc.querySelector(".shopify-section.product-section").innerHTML}</div>`;
      window.productHTml = doc;
      
      document.querySelector(".custom-model-main[data-quickView-popup] .cart-popup-content").innerHTML = productHTml;
      var btnHtml = `<a class="page_redirect_btn" href="${productUrl}">${window.seeAllDetails}</a>`;
      document.querySelector(".custom-model-main[data-quickView-popup] .custom-model-inner .btn--main").innerHTML = btnHtml
      // document.querySelector(".loading-cart-modal[loading-for-quickview]").style.display = "none";
      $this.openQuickView();
      $this.addAttributesInSubmitBtn(doc);
      setTimeout(function(){
        $this.attectEvents(document.querySelector('[data-quickview-popup]'));
        
        $this.doAddOrRemoveWishlish();
        var mainSlider;
        if(document.querySelectorAll('[product--main-image-flickity] .slider__slide ').length > 1){
          mainSlider = new Flickity( '[product--main-image-flickity]',{
            // options
            contain: true,
            adaptiveHeight: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            asNavFor: '[product--thumbnail-image-flickity]',
          });
        }
        
        
        if(document.querySelector('[product--thumbnail-image]') && document.querySelectorAll('[product--thumbnail-image-flickity] .thumb-slider__slide').length > 2){
         
          let thumbSlider = new Flickity( '[product--thumbnail-image-flickity]',{
            // options
            contain: true,  
            pageDots: false,
            adaptiveHeight: true,
            prevNextButtons: true,
            cellAlign: 'left',
            wrapAround: true,
            draggable:true
          });
          
          thumbSlider.on('staticClick',function( event, pointer, cellElement, cellIndex ){
            mainSlider.select(cellIndex);
          })
          
          mainSlider.on('change',function(event){
            thumbSlider.select(event)
          })
          
        }else{
          document.querySelectorAll('[product--thumbnail-image] [data-thumb-event]').forEach(function(ele){
            ele.addEventListener('click',function(){
              var index = this.dataset.thumbEvent;
              mainSlider.select(index);
            })
          })
        }
      },1500)
      new VariantRadios('quickview');
      new ProductForm();
//       ella.init();
      
    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    });
  },
  addAttributesInSubmitBtn:function(doc){
    var variant_id = doc.querySelector("product-form.product-form input[name='id']").value;
    var quentity,btn_selector = document.querySelector('.product-form__buttons button[type="submit"]');
    if(doc.querySelector('quantity-input.quantity input[class="quantity__input"]')){
      quentity = doc.querySelector('quantity-input.quantity input[class="quantity__input"]').value
    }
    if(btn_selector){
      btn_selector.setAttribute("data-variant-id",variant_id);
      btn_selector.setAttribute("data-quantity",quentity);
    }
  },
  attectEvents:function(productHTml){
    document.querySelector(".custom-model-main[data-quickView-popup] .custom-model-inner .close-btn").addEventListener("click",ella.closeQuickView);
    document.querySelector(".wrapper-overlay[overlay-of_quickview]").addEventListener("click",ella.closeQuickView);
    if(productHTml.querySelector('[data-product-quantity]')){
      productHTml.querySelector('[data-product-quantity]').addEventListener('change',function(){
        var productPrice = parseInt(this.dataset.productPrice) * parseInt(this.value),
            formatePrice = window.Shopify.formatMoney(productPrice,window.money_format);
        productHTml.querySelector('.product-form__buttons button[type="submit"] price').innerText = formatePrice;
        productHTml.querySelector('.product-form__buttons button[type="submit"]').dataset.quantity = this.value;
      })
    }
    /*productHTml.querySelectorAll(".quantity .quantity__button").forEach(function(evt){
      evt.addEventListener("click",function(event){
        console.log("hiiii",this,event)
      })
    })
    if(productHTml.querySelector('.product-form__buttons button[type="submit"]')){
      productHTml.querySelector('.product-form__buttons button[type="submit"]').addEventListener("click",function(event){
        event.preventDefault();
        ella.addToCart(productHTml,event);
      });
    }*/
  },
  addToCart:function(productHTml,event){
//     add(event);
    window.addToCart(event,'','',window.enable_popup)
  },
  openQuickView:function(){
    document.querySelector(".custom-model-main[data-quickView-popup]").classList.add("model-open");
  },
  closeQuickView:function(){
    document.body.classList.remove('overflow-hidden');
    document.querySelector(".custom-model-main[data-quickView-popup]").classList.remove("model-open");
    document.querySelector(".custom-model-main[data-quickView-popup]").classList.add("model-close");
  },
  
  initStickyAddToCart: function() {
    var blockSticky = $('[data-sticky-add-to-cart]'),
        sltVariantActive = blockSticky.find('.pr-active'),
        variantElm = blockSticky.find('.pr-swatch');

    if(blockSticky.length) {
      var showHideVariantsOptions = function() {
        sltVariantActive.off('click.showListVariant').on('click.showListVariant', function(e) {
          e.preventDefault();

          blockSticky.toggleClass('open-sticky');
        });

        $(document).off('click.hideVariantsOption').on('click.hideVariantsOption', function(e) {
          if (!sltVariantActive.is(e.target) && sltVariantActive.has(e.target).length === 0){
            blockSticky.removeClass('open-sticky');
          };
        })
      };

      var handleActiveVariant = function() {
        variantElm.off('click.activeVar').on('click.activeVar', function(e) {
          var self = $(this),
              text = self.text(),
              value = self.data('value'),
              newImage = self.data('img'),
              stock = self.data('stock'),
              variantId = self.data('sticky-variant-dropdown');
          
          $(`[data-sticky-add-to-cart] .quantity__input[name="quantity"]`).attr('data-max-value',stock);
          $(`[data-sticky-add-to-cart] .quantity__input[name="quantity"]`).val(1)
          $(`[data-radio-variant="${variantId}"]`).trigger('click');

          variantElm.removeClass('active');
          self.addClass('active');
          blockSticky.toggleClass('open-sticky');

//           console.log(value)
          blockSticky.find('.action input[type="hidden"][name="id"]').val(value);
          sltVariantActive.attr('data-value', value).text(text);

          var swatchNameValue = $('#add-to-cart-form [data-value-sticky="'+value+'"]');

          swatchNameValue.each(function() {
            var slt = $(this).data('value');

            $('[data-value="'+slt+'"]').closest('.swatch').find('#'+slt+'').click();
          });

          if(self.hasClass('sold-out')) {
            blockSticky.find('.sticky-add-to-cart').val(window.inventory_text.sold_out).addClass('disabled').attr('disabled', 'disabled');
          }else {
            blockSticky.find('.sticky-add-to-cart').removeClass('disabled').removeAttr('disabled').val(window.inventory_text.add_to_cart);
          };

          $('.pr-img img').attr({ src: newImage });

          return false;
        });
      };


      var activeVariantSelected = function() {
        var optionSelected = $('#product-selectors option:selected'),
            value = optionSelected.val(),
            stickyActive = blockSticky.find('.pr-swatch[data-value="'+value+'"]'),
            stickyText = stickyActive.text();

        sltVariantActive.text(stickyText);
        stickyActive.addClass('active');

        var str = stickyActive.data('img');

        $('.pr-img img').attr({ src: str });

        $(".swatch .swatch-element").each(function(e) {
          var idVariant = $(this).find('input:radio').attr('id');

          $('.swatch input.text[data-value="'+idVariant+'"]').appendTo($(this));
        });

        $('.selector-wrapper').change(function() {
          var n = $("#product-selectors").val();

          $('.sticky_form .pr-selectors li').each(function(e) {
            var t = $(this).find('a').data('value');

            if(t == n){
              $(this).find('a').addClass('active')
            } else{
              $(this).find('a').removeClass('active')
            }
          });

          $("#product-selectors").change(function() {
            var str = "";

            $("#product-selectors option:selected").each(function() {
              str += $(this).data('imge');
            });

            $('.pr-img img').attr({ src: str });
          }).trigger("change");

          if(variantElm.hasClass('active')) {
            var h = $('.sticky_form .pr-swatch.active').text();

            $('.sticky_form .action input[type=hidden]').val(n);
            sltVariantActive.text(h);
            sltVariantActive.attr('data-value', n);
          };
        });
      };


      showHideVariantsOptions();
      handleActiveVariant();
      activeVariantSelected();
    };
  }
}
ella.init();
window.wishlistAndQuickviewFunction = ella.init;

var newslatter = {
  initNewsLetterPopup: function () {
    if (window.newsletter_popup) {
      var newsletterWrapper = $('[data-newsletter]'),
          closeWindow = newsletterWrapper.find('.close-window'),
          delay = newsletterWrapper.data('delay'),
          modalContent = newsletterWrapper.find('.halo-modal-content');

      console.log($.cookie('emailSubcribeModal'),"closeWindow :: ",closeWindow);
      if ($.cookie('emailSubcribeModal') != 'closed') {
        newslatter.ellaTimeout = setTimeout(function () {
          newslatter.openEmailModalWindow(newsletterWrapper);
        }, delay);
      };

      closeWindow.click(function (e) {
        e.preventDefault();
        newslatter.closeEmailModalWindow(newsletterWrapper);
      });

      newsletterWrapper.on('click', function (e) {
        if (!modalContent.is(e.target) && !modalContent.has(e.target).length) {
          newslatter.closeEmailModalWindow(newsletterWrapper);
        };
      });

      $('#mc_embed_signup form').submit(function () {
        if ($('#mc_embed_signup .email').val() != '') {
          newslatter.closeEmailModalWindow(newsletterWrapper);
        };
      });
    };
  },
  openEmailModalWindow: function (newsletterWrapper) {
    newsletterWrapper.fadeIn(1000);
  },

  closeEmailModalWindow: function (newsletterWrapper) {
    newsletterWrapper.fadeOut(1000);

    $.cookie('emailSubcribeModal', 'closed', {
      expires: 1,
      path: '/'
    });
    
    var inputChecked = newsletterWrapper.find('input[name="dismiss"]').prop('checked');
    if (inputChecked || !newsletterWrapper.find('input[name="dismiss"]').length){
    }
  }
}
newslatter.initNewsLetterPopup();

var muiltiLangCurrency = {
  initToggleMuiltiLangCurrency:function(){
    var langCurrencyGroups = $('.lang-currency-groups'),
        dropdownGroup = langCurrencyGroups.find('.btn-group'),
        dropdownLabel = dropdownGroup.find('.dropdown-label');

    if (dropdownLabel.length && dropdownLabel.is(':visible')) {
      dropdownLabel.off('click.toggleMuiltiOption').on('click.toggleMuiltiOption', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var selfNextDropdown = $(this).next();

        if (!selfNextDropdown.is(':visible')) {
          dropdownLabel.next('.dropdown-menu').hide();
          selfNextDropdown.slideDown(300);
        } else {
          selfNextDropdown.slideUp(300);
        }
      });

      muiltiLangCurrency.hideMuiltiLangCurrency();
    } else {
      dropdownLabel.next('.dropdown-menu').css({
        'display': ''
      });
    };
  },
  hideMuiltiLangCurrency: function(){
    $(document).off('click.hideMuiltiLangCurrency').on('click.hideMuiltiLangCurrency', function (e) {
      var muiltiDropdown = $('.lang-currency-groups .dropdown-menu');

      if (!muiltiDropdown.is(e.target) && !muiltiDropdown.has(e.target).length) {
        muiltiDropdown.slideUp(300);
      }
    });
  }
}
muiltiLangCurrency.initToggleMuiltiLangCurrency();

/*
var collection = {
  init:function(){
    if(body.classList.contains('template-collection') || body.classList.contains('template-search')) {
      //console.log("hiii")
//       this.historyAdapter();
//       this.initInfiniteScrolling();
//       this.initPaginationPage();
    }
  },
  historyAdapter: function () {
    var collTpl = document.querySelector('[data-section-type="collection-template"]');
console.log("hiii",collTpl,collTpl.length)
    if (collTpl.length) {
      
      History.Adapter.bind(window, 'statechange', function () {
        var State = History.getState();

        if (!ella.isSidebarAjaxClick) {
          ella.queryParams();

          var newurl = ella.ajaxCreateUrl();

          ella.doAjaxToolbarGetContent(newurl);
          ella.doAjaxSidebarGetContent(newurl);
        }

        ella.isSidebarAjaxClick = false;
      });
    };
  },
}

collection.init();*/

if(window.outerWidth > 768 ){
  if($(".product-inBox-zoom").length){
    $(".product-inBox-zoom").zoom();
  }
}